import { fg } from '@atlaskit/platform-feature-flags';
import { componentWithCondition } from '../component-with-condition';
export var componentWithFG = function componentWithFG(featureFlagName, ComponentTrue, ComponentFalse
// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-registration, @atlaskit/platform/static-feature-flags
) {
  return componentWithCondition(function () {
    return fg(featureFlagName);
  }, ComponentTrue, ComponentFalse);
};